import { render, staticRenderFns } from "./SingleVisionModule.vue?vue&type=template&id=5f1e2832&scoped=true&"
import script from "./SingleVisionModule.vue?vue&type=script&lang=js&"
export * from "./SingleVisionModule.vue?vue&type=script&lang=js&"
import style0 from "./SingleVisionModule.vue?vue&type=style&index=0&id=5f1e2832&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1e2832",
  null
  
)

export default component.exports